import type { CityConfig } from "@/pages/city-template/types";

export const amsterdamNyConfig: CityConfig = {
  city: "Amsterdam",
  state: "New York",
  stateAbbr: "NY",
  slug: "amsterdam-ny",
  route: "/cities/amsterdam-ny",
  title: "Emergency & Expedited Passport Amsterdam, NY | Same Day Passport Services",
  metaDescription:
    "Emergency passport Amsterdam NY — same day, 24-hour, and 3-5 day expedited passport processing. Fast Passport Center serves Amsterdam, Fonda, Fort Plain, Canajoharie, and all of Montgomery County. Avoid the 8-11 week wait.",
  h1: "Emergency & Expedited Passport Services in Amsterdam, NY",
  heroSubtitle:
    "Amsterdam sits at the heart of the Mohawk Valley, where the Erie Canal once moved the nation. Today, its travelers need passport service that moves just as fast. Fast Passport Center delivers emergency passports as quick as 24 hours, with 3-5 day expedited service for Amsterdam, Montgomery County, and the entire Mohawk Valley corridor.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Historic%20Amsterdam%20New%20York%20downtown%20along%20the%20Mohawk%20River%20with%20historic%20brick%20mill%20buildings%20and%20waterfront%20park%2C%20Erie%20Canal%20heritage%2C%20warm%20golden%20hour%20lighting%2C%20Upstate%20New%20York%20small%20city%20architecture%2C%20scenic%20river%20valley%20with%20rolling%20hills%20in%20background%2C%20modern%20travel%20photography%2C%20clean%20composition%2C%20no%20text%20overlay%2C%20high%20contrast%20landscape&width=1600&height=700&seq=ny-amsterdam-hero-001&orientation=landscape",
  heroImageAlt: "Historic Amsterdam New York downtown along the Mohawk River with historic brick mill buildings",
  geoPosition: "42.9387; -74.1882",
  geoPlacename: "Amsterdam, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~175 miles from Amsterdam",
  },
  nearbyCitiesZips: [
    { name: "Amsterdam", zips: "12010" },
    { name: "Fonda", zips: "12068" },
    { name: "Fort Plain", zips: "13339" },
    { name: "Canajoharie", zips: "13317" },
    { name: "Fultonville", zips: "12072" },
    { name: "Tribes Hill", zips: "12177" },
    { name: "Hagaman", zips: "12086" },
    { name: "Florida", zips: "12010" },
    { name: "Gloversville", zips: "12078" },
    { name: "Johnstown", zips: "12095" },
    { name: "Broadalbin", zips: "12025" },
    { name: "Mayfield", zips: "12117" },
    { name: "St. Johnsville", zips: "13452" },
    { name: "Palatine Bridge", zips: "13428" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Utica", zips: "13501-13505, 13599" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Syracuse", zips: "13201-13211, 13214-13220, 13224-13235, 13244, 13250, 13251, 13252, 13261, 13290" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Amsterdam travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with reserved agency submission slots.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Mohawk Valley Coverage",
      desc: "Amsterdam, Fonda, Fort Plain, Canajoharie, and every community in Montgomery and Fulton Counties.",
    },
  ],
  testimonials: [
    {
      name: "Tom H.",
      location: "Amsterdam, NY",
      rating: 5,
      text: "I work at the Mohawk Valley textile mill and needed an emergency passport for a business trip to Germany. Fast Passport Center got it done in 5 days. Saved my job and the trip.",
      service: "Emergency Passport",
    },
    {
      name: "Linda M.",
      location: "Fonda, NY",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center from Fonda. The 10-day Smart Saver option was perfect — had it back in 8 days. Very smooth process.",
      service: "Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Fort Plain, NY",
      rating: 5,
      text: "First-time passport for my whole family before our trip to the Caribbean. The agent walked us through the parental consent requirements and everything went perfectly.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "ams-1",
      name: "Amsterdam Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "10 Empire Street",
      city: "Amsterdam",
      state: "NY",
      zip: "12010",
      phone: "518-842-8210",
      hours: "Mon-Fri 8:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Amsterdam",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Amsterdam and Montgomery County residents. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "ams-2",
      name: "Fort Plain Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "40 Main Street",
      city: "Fort Plain",
      state: "NY",
      zip: "13339",
      phone: "518-993-4321",
      hours: "Mon-Fri 8:00 AM - 4:00 PM",
      distance: "Fort Plain, NY (~15 miles from Amsterdam)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available for Fort Plain and western Montgomery County residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "ams-3",
      name: "Gloversville Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "3 Frontage Road",
      city: "Gloversville",
      state: "NY",
      zip: "12078",
      phone: "518-725-4121",
      hours: "Mon-Fri 8:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Gloversville, NY (~20 miles from Amsterdam)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance facility serving Gloversville, Johnstown, and Fulton County residents.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Amsterdam, NY?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Amsterdam residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Amsterdam?",
      a: "The Amsterdam Post Office at 10 Empire Street offers passport acceptance services. The Fort Plain Post Office at 40 Main Street (~15 miles) and Gloversville Post Office at 3 Frontage Road (~20 miles) are also nearby alternatives. First-time applicants and those not eligible for mail-in renewal must apply in person at these facilities.",
    },
    {
      q: "Can I get same-day passport photos in Amsterdam, NY?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and Walmart locations in Amsterdam and nearby Fonda. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements before submission.",
    },
    {
      q: "How much does an expedited passport cost in Amsterdam?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Amsterdam passport needs.",
    },
    {
      q: "Do I need to drive to the New York Passport Agency from Amsterdam?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency at 376 Hudson Street in Manhattan at all. As a registered courier, we handle the agency submission for you. The drive is approximately 175 miles, making it impractical for most Amsterdam residents.",
    },
    {
      q: "What is the fastest way to renew a passport in Amsterdam, New York?",
      a: "The fastest way to renew a passport in Amsterdam is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit.",
    },
    {
      q: "Can I get a child passport expedited in Amsterdam, NY?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Amsterdam and all of Montgomery County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Amsterdam, NY?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Amsterdam. We serve Amsterdam and the Mohawk Valley through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Amsterdam", address: "various CVS locations in Amsterdam and Fonda", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Amsterdam", address: "various Walgreens locations near Amsterdam", hours: "Mon-Sun, hours vary by location" },
    { name: "Walmart — Amsterdam", address: "various Walmart locations near Amsterdam", hours: "Mon-Sun 7:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Amsterdam",
      address: "55 E Main Street, Amsterdam, NY 12010",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Amsterdam DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Fonda",
      address: "6 County Highway 153, Fonda, NY 12068",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Fonda DMV office for Montgomery County residents. Convenient for Fonda, Fort Plain, and Canajoharie residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~40 miles from Amsterdam",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with domestic flights and some seasonal international connections. Most convenient for Amsterdam-area travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~90 miles from Amsterdam",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Central New York's major airport with domestic and some international service. Alternative option for Amsterdam travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~175 miles from Amsterdam",
      address: "Queens, NY 11430",
      note: "NYC's primary international airport with direct flights worldwide. Many Amsterdam travelers use JFK for long-haul international travel.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Amsterdam travelers with urgent departures within 24 hours to 2 weeks. Reserved agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Amsterdam residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Amsterdam residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Amsterdam residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Amsterdam, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Amsterdam residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Amsterdam travelers with immediate departure needs." },
    { name: "Passport Renewal", description: "Fast passport renewal for Amsterdam residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Amsterdam residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Amsterdam residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Amsterdam." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Amsterdam." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Amsterdam travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Amsterdam travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Mohawk Valley team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application with reserved agency processing slots.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Amsterdam address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Rome", route: "/cities/rome-ny" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Ballston Spa", route: "/cities/ballston-spa" },
    { name: "Hudson", route: "/cities/hudson-ny" },
    { name: "Catskill", route: "/cities/catskill" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Amsterdam and all of the Mohawk Valley as a remote courier service. We do not have a physical office in Amsterdam, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Amsterdam, NY area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Amsterdam and all surrounding Mohawk Valley communities. From Fonda to Fort Plain, Canajoharie to Gloversville — we serve every community in Montgomery and Fulton Counties with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Amsterdam and all surrounding Mohawk Valley communities. Whether you're in the city, a village, or a rural town, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Amsterdam customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Amsterdam travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Amsterdam and Mohawk Valley travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Amsterdam, NY. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default amsterdamNyConfig;